import { normalizarData, normalizarValor } from '../../utils/index';
import { adicionarDiasUteis } from '../../utils/feriadosFebraban';

/**
 * Retorna TRUE se o array de dados se parecer com o arquivo VENDAS TUNA.
 */
export const detectar = (dadosArray) => {
    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        // Remove possível BOM e trim
        const cleanRow = linha.map(c => String(c || '').trim().replace(/^\uFEFF/, '').toLowerCase());
        
        if (
            cleanRow.includes('id tuna') && 
            cleanRow.includes('valor') && 
            cleanRow.includes('método de pagamento') &&
            cleanRow.includes('status')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa o VENDAS TUNA e gera uma simulação de recebimentos
 * pulando sábados, domingos e feriados bancários (Febraban).
 */
export const processar = (dadosArray) => {
    let idxData = -1;
    let idxValor = -1;
    let idxStatus = -1;
    let idxMetodo = -1;
    let idxCabecalho = -1;

    for (let i = 0; i < Math.min(dadosArray.length, 10); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().replace(/^\uFEFF/, '').toLowerCase());
        
        const possibleDataIdx = cleanRow.indexOf('data');
        const possibleValorIdx = cleanRow.indexOf('valor');
        const possibleStatusIdx = cleanRow.indexOf('status');
        const possibleMetodoIdx = cleanRow.indexOf('método de pagamento');

        if (possibleDataIdx !== -1 && possibleValorIdx !== -1 && possibleStatusIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxValor = possibleValorIdx;
            idxStatus = possibleStatusIdx;
            idxMetodo = possibleMetodoIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho Vendas Tuna não encontrado.');
    }

    const repasses = [];

    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || !linha[idxData]) continue;

        const statusRaw = String(linha[idxStatus] || '').trim().toLowerCase();
        if (statusRaw !== 'finalizado') continue; // Apenas vendas bem sucedidas

        const rawDate = String(linha[idxData]).trim().split(' ')[0]; // Pega só a data DD/MM/YYYY
        if (!rawDate) continue;

        // Normaliza DD/MM/YYYY para YYYY-MM-DD
        let isoDate = rawDate;
        if (rawDate.includes('/')) {
            const parts = rawDate.split('/');
            isoDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }

        // Calcula a data de repasse (D+1 dias úteis bancários)
        const dataRepasse = adicionarDiasUteis(isoDate, 1);

        const valorBruto = parseFloat(String(linha[idxValor] || '').replace(/[R$\s]/g, '').replace(/\./g, '').replace(',', '.')) || 0;
        
        // Conforme análise, a Tuna deposita o valor bruto exato das vendas Pix em D+1
        const valorLiquido = valorBruto;
        
        let metodoPagamento = 'Venda';
        if (idxMetodo !== -1 && linha[idxMetodo]) {
            metodoPagamento = String(linha[idxMetodo]).trim();
        }

        if (valorLiquido > 0) {
            repasses.push({
                data: dataRepasse,
                valor: valorLiquido,
                id_lote: `TUNA-SIMULADO-${i}`,
                tipo: metodoPagamento,
                origem: 'Tuna'
            });
        }
    }

    return repasses;
};
